import { useState, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { StaticImage } from 'gatsby-plugin-image';

const ease = [0.6, 0.05, 0.01, 0.9];

export const Panels = ({ path }) => {
  const [isInitial, setIsInitial] = useState(true);
  const controls = useAnimation();

  useEffect(() => {
    const startingHeight = isInitial ? '100vh' : '0vh';
    const startingTop = isInitial ? '0vh' : '100vh';

    controls.start(() => ({
      height: [startingHeight, '100vh', '100vh', `0vh`],
      top: [startingTop, '0vh', '0vh', '0vh'],
    }));

    if (isInitial) setIsInitial(false);
  }, [path]);

  return (
    <div className="panels">
      <motion.div
        animate={controls}
        transition={{
          duration: 2,
          times: [0, 0.33, 0.66, 1],
          type: 'tween',
          ease,
        }}
        className="full-panel"
      >
        <div className="panel-background">
          <StaticImage
            src="../../images/seeds-of-growth-panel.png"
            alt=""
            placeholder="none"
          />
        </div>
      </motion.div>
    </div>
  );
};
